/**
 * Load Callrail
 */

export const loadCallrail = () => {
  const callRailScript = document.createElement('script')
  callRailScript.src =
    '//cdn.callrail.com/companies/460222659/681dd7f0fd28ea2dd0e9/12/swap.js'
  document.body.appendChild(callRailScript)
}
